import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import LOTOPlacard from '../assets/safety/2.3-main-pdp-loto.png';
import LOTOLock from '../../../../assets/safety/2.13-typical-multi-lock-device.png';
import { FaHome } from 'react-icons/fa';
import HomeNav from '../../../../components/HomeNav';

import 'bootstrap/dist/css/bootstrap.min.css';

// 2.12 MASTER KEY BOX SYSTEM

const SIEquipmentLockout = () => {
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment Lockout</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Equipment Lockout" className="mb-3 safety-element">
								<Tab eventKey="Equipment Lockout" title="Equipment Lockout">
									<div class="tab-section">
										<div class="eq-lock">
											<div class="left-side">
												<h2>EQUIPMENT LOCKOUT PROCEDURE</h2>
												<p>If the machine or equipment is operating, it shall be shut down using normal shutdown procedures. Refer to the operating section of this manual for shutdown procedures.</p>
												<p>
													When service or maintenance is to be conducted, the equipment must be locked and tagged out following all plant <b>LOTO</b> procedures. Other alternative measures that provide effective employee protection may be used for conducting minor inspections, adjustments, or servicing.
												</p>
												<p>Before shutting down the equipment to lockout energy sources, the employee performing the procedure, or the supervisor shall inform affected employees (such as equipment/process operators) of the intention to shut down the equipment.</p>
												<p>
													Consult the lockout / tagout placard posted on the main electrical power distribution panel (<b>PDP</b>) to assess the task to be performed as it relates to the energy sources that could cause injury if energized or released during the assigned task. The employee should contact his/her immediate supervisor if there are any questions about the identification of potential energy sources.
												</p>

												<p>
													Consult the graphic placard and procedures placard posted on the main electrical power distribution panel (<b>PDP</b>) to assess the task to be performed as it relates to the energy sources that could cause injury if energized or released during the assigned task. The employee should contact his/her immediate supervisor if there are any questions about the identification of potential energy sources.
												</p>

												<div class="eq-lock">
													<div class="right-side" style={{ width: '100%' }}>
														<div class="note">
															<p>If more than one person is to perform work on the equipment, each employee must place his / her personal safety lock on the safety gate and the energy source using a multiple lock device (scissor lock).</p>
														</div>
													</div>
													<div class="left-side">
														<figure>
															<img src={LOTOLock} alt="Lockout Tagout Lock" />
															<figcaption>Figure 1: Typical Multiple Lock Device</figcaption>
														</figure>
													</div>
												</div>
											</div>

											<div class="right-side">
												<div class="note">
													<p>
														Refer to the <b>LOTO</b> Placard posted on the equipment for energy sources, lockout procedures, and verification procedures.
													</p>
												</div>
												<figure>
													<img src={LOTOPlacard} alt="Lockout Tagout Placard" style={{ width: '75vh' }} />
													<figcaption>Figure 2: Main PDP LOTO Placard</figcaption>
												</figure>
											</div>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIEquipmentLockout;
